import { useState } from 'react';
import {
  useNavigate,
  useParams,
} from 'react-router-dom';

import { Header } from '@/presentation/components';
import { AppDrawer } from '@/presentation/components/layout/AppDrawer/AppDrawer';
import { BottomAppBar } from '@/presentation/components/layout/BottomAppBar/BottomAppBar';
import { useAuthContext } from '@/presentation/context';
import { routes } from '@/presentation/router';

import { RepuestosSection } from './components/RepuestosSection';


export default function ActionPage() {
  const navigate = useNavigate();
  const { id } = useParams();


  const { user, logout } =
    useAuthContext();

  const [isDrawerOpen, setIsDrawerOpen] =
    useState(false);
  
  
  

  const incidenteId = id ?? '0';

  const handleLogout = async () => {
    await logout();

    setIsDrawerOpen(false);

    navigate(routes.login, {
      replace: true,
    });
  };
  
  
  
  
  
  
  

  return (
    <div>
      <Header
        title="Repuestos del Incidente"
        onMenuClick={() =>
          setIsDrawerOpen(true)
        }
      />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={() =>
          setIsDrawerOpen(false)
        }
        onLogout={handleLogout}
      />
      <main style={{ padding: '24px' }}>
        <RepuestosSection
          incidenteId={incidenteId}
        />

      </main>




      <BottomAppBar
        items={[
          {
            label: 'Listo',
            onClick: () => {navigate(`/incidente/${incidenteId}`)},
            icon: undefined,
          },
          
        ]}
      />
      </div>
  );
}